const imgUrl = [
  require('../../../assets/img/solutions/客车.png'),
  require('../../../assets/img/solutions/coach/map.png'),
  require('../../../assets/img/solutions/coach/car1.png'),
  require('../../../assets/img/solutions/coach/wifi.png'),
  require('../../../assets/img/solutions/coach/car2.png'),
  require('../../../assets/img/solutions/coach/drive1.png'),
  require('../../../assets/img/solutions/coach/drive2.png'),
  require('../../../assets/img/solutions/coach/camera.png'),
];

export default imgUrl;
